// #region Global Imports
import * as React from 'react';
// #endregion Global Imports
// #region Local Imports
import type { ParagraphsPostFragment } from '@components/Paragraphs';
import { Paragraphs } from '@components/Paragraphs';
import { gql } from '@generated/gql';
import type { FragmentType } from '@generated/fragment-masking';
import { getFragmentData } from '@generated/fragment-masking';
import styles from '../PostContent/styles.module.sass';
// #endregion Local Imports

export const PageContentFragment = gql(/* GraphQL */ `
  fragment PageContentFragment on NodePage {
    uuid
    title

    entityUrl {
      path
    }

    webform: fieldForm {
      targetId
    }

    ...ParagraphsPageFragment
  }
`);
export const PageContent: React.FC<{
  pageContent: FragmentType<typeof PageContentFragment>;
}> = ({ pageContent: _pageContent }) => {
  const pageContent = getFragmentData(PageContentFragment, _pageContent);

  return (
    <div className={styles.PageContent__root}>
      <h1 className={styles.PageContent__headline}>{pageContent.title}</h1>
      <Paragraphs
        entity={pageContent as FragmentType<typeof ParagraphsPostFragment>}
      />
    </div>
  );
};
